import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { blueGrey } from '@mui/material/colors';
import { TEXT_PRIMARY } from '../app.styles';

export const StyledIconButton = styled(IconButton)<IconButtonProps<'a'>>({
  backgroundColor: 'transparent',
  color: TEXT_PRIMARY,
  '&:hover': {
    backgroundColor: 'transparent',
    color: blueGrey[600],
  },
});
